import { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import { useUiStore } from '@/stores/ui';

export function RouteTracker() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const prevPathRef = useRef(pathname);
  const prevSearchRef = useRef(searchParams.toString());

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const prevSearch = prevSearchRef.current;
    const currentSearch = searchParams.toString();

    const prevHasTab = new URLSearchParams(prevSearch).has('tab');
    const currentHasTab = searchParams.has('tab');

    // Skip if both routes have tab query param (preserve "page back" behaviour)
    if (prevHasTab && currentHasTab) {
      prevPathRef.current = pathname;
      prevSearchRef.current = currentSearch;
      return;
    }

    if (pathname !== prevPath) {
      const prevFullPath = prevSearch ? `${prevPath}?${prevSearch}` : prevPath;
      useUiStore.getState().setPreviousPageRoute(prevFullPath);
    }

    prevPathRef.current = pathname;
    prevSearchRef.current = currentSearch;
  }, [pathname, searchParams]);

  return null;
}
